<template>
	<div>
		<v-alert v-if="!inquiry && !loading" type="warning" icon="mdi-information-outline" outlined>
			خطا در آماده سازی کامپاننت استعلام
		</v-alert>
		<v-card v-else class="rounded-xl pa-3" elevation="0" style="border: 1px solid #ddd;">
			<div class="d-flex align-center">
				<v-chip v-if="loading" color="grey lighten-4" inline>
					<v-icon color="grey" class="ml-3">
						mdi-timer-sand
					</v-icon>
					<div class="text-subtitle-1 grey--text">
						در حال دریافت اطلاعات...
					</div>
				</v-chip>

				<v-chip v-else :color="`${inquiry.badgeColor} lighten-4`" class="mb-2" inline>
					<v-icon :color="inquiry.badgeColor" class="ml-3">
						{{ inquiry.icon }}
					</v-icon>
					<v-icon :color="inquiry.badgeColor" small class="ml-1">
						{{ inquiry.statusIcon }}
					</v-icon>
					<div class="text-subtitle-1" :class="`${inquiry.badgeColor}--text`">
						{{ title }}
					</div>
				</v-chip>
				<v-spacer />
				<div class="text-center d-flex flex-column" v-show="!loading">
					<div class="text-center ">
						<v-btn outlined block small color="secondary" :loading="submitInquiryLoading" class="rounded-lg mb-1" @click="submitInquiry()">
							<v-icon left small>mdi-plus</v-icon>
							<div>
								استعلام جدید
								<br />
								<small>{{ businessAuthorizationPrice > 0 ? `(هزینه: ${String(businessAuthorizationPrice).toPriceFormat()} تومان)` : '' }}</small>
							</div>
						</v-btn>
					</div>
					<div class="text-center " v-if="businessAuthorizationPrice > 0">
						<v-btn outlined block blocked small color="secondary" class="rounded-lg" @click="dialogWalletCreditCharge = true">
							<v-icon left small>mdi-currency-usd</v-icon>
							شارژ کیف پول
						</v-btn>
					</div>
				</div>
			</div>
			<v-divider class="mt-2" />

			<div class="pa-0" v-if="inquiry && !loading">
				<v-alert v-if="!inquiry.items.length && isGroupExpanded" type="warning" icon="mdi-information-outline" outlined class="ma-2">
					استعلامی یافت نشد.
				</v-alert>
				<v-list two-line dense class="py-0" v-show="inquiry.items.length && isGroupExpanded">
					<v-list-item v-for="(item, idx) in inquiry.items" :key="idx" style="border-bottom: 1px dashed #eee;">
						<v-list-item-content>
							<v-list-item-title class="d-flex align-center justify-space-between">
								<span class="ml-2">&lrm;{{ item.dateTime }}</span>
								<v-chip small label class="ml-1" color="teal lighten-5" text-color="teal darken-2">
									<v-icon left x-small>mdi-currency-usd</v-icon>
									{{ formatPrice(item.cost) }} تومان
								</v-chip>
							</v-list-item-title>
							<v-list-item-subtitle class="d-flex align-center flex-wrap">
								<v-chip x-small class="ml-1 mb-1" :color="resultColor(item.result)" text-color="white" label>
									<v-icon left x-small>mdi-check-decagram</v-icon>
									{{ normalizeResult(item.result) }}
								</v-chip>
							</v-list-item-subtitle>
						</v-list-item-content>
					</v-list-item>
				</v-list>
				<div class=" text-center">
					<v-btn text small color="secondary" @click="isGroupExpanded = !isGroupExpanded" class="rounded-lg">
						<v-icon left small>
							{{ isGroupExpanded ? 'mdi-chevron-up' : 'mdi-chevron-down' }}
						</v-icon>
						{{ isGroupExpanded ? 'بستن لیست' : 'سابقه استعلام ها' + ` (تعداد: ${(inquiry.items || []).length})` }}
					</v-btn>
				</div>
			</div>
		</v-card>


		<v-dialog v-model="dialogWalletCreditCharge" scrollable persistent max-width="450px">
			<v-card>
				<v-card-title>
					<div><span class="headline">شارژ کیف پول</span></div>
					<v-spacer />
					<v-btn @click="dialogWalletCreditCharge = false" icon>
						<v-icon>mdi-close</v-icon>
					</v-btn>
				</v-card-title>
				<v-card-text>
					<v-container>
						<WalletCreditCharge ref="walletCreditCharge" v-if="dialogWalletCreditCharge" @callbck="callbck_walletCreditCharge" :area="area" :data="{ id: memberId }" />
					</v-container>
				</v-card-text>
			</v-card>
		</v-dialog>

		<!-- confirm dialog placeholder in case we need later -->
		<confirm-dlg ref="confirm" />
	</div>
</template>

<script>
	import api from '@/util/app-api'
	import toast from '@/util/toast'
	import { get, call } from 'vuex-pathify'
	import { base_inquiries } from '@/plugins/inquiries.js'
	import { emptyId } from '@/util/emptyId'
	import { cloneDeep } from 'lodash'

	export default {
		name: 'MemberInquiry',
		props: {
			memberId: { type: Number, required: true },
			memberAuthorizationItem: { type: Object, default: null },
			userLoanRequestAuthorizationItem: { type: Object, default: null },
			type: { type: Number, default: -1 },
			area: { type: String, default: null },
		},
		components: {
			ConfirmDlg: () => import('@/components/Confirm'),
			WalletCreditCharge: () => import('@/components/forms/WalletCreditCharge'),
		},
		data() {
			return {
				dialogWalletCreditCharge: false,
				loading: false,
				errorMessage: '',
				inquiry: null,
				submitInquiryLoading: false,
				isGroupExpanded: false,
				localMemberAuthorizationItem: null
			}
		},
		computed: {
			businessAuthorizations: get('businessAuthorizations/all'),
			title() {
				if (this.loading)
					return 'در حال دریافت اطلاعات'
				if (!this.inquiry?.items?.length)
					return 'استعلامی تاکنون اخذ نشده است'
				return this.normalizeResult(this.inquiry.result)
			},
			businessAuthorizationPrice() {
				return this.businessAuthorizations.find(x => x.authorizationItem.id === (this.memberAuthorizationItem?.authorizationItem?.id || this.userLoanRequestAuthorizationItem?.authorizationItem?.id))?.cost || 0
			}
		},
		watch: {
			memberAuthorizationItem: {
				immediate: true,
				handler(val, oldVal) {
					this.localMemberAuthorizationItem = cloneDeep(val)
				}
			}
		},
		mounted() {
			this.bootstrap()
		},
		methods: {
			fetchBusinessAuthorizations: call('businessAuthorizations/fetch'),
			async bootstrap() {
				this.errorMessage = ''
				this.fetchBusinessAuthorizations()
				await this.loadInquiries()
			},
			async loadInquiries() {
				if (!this.memberId || this.type === -1) return
				this.loading = true
				this.inquiry = null
				try {
					const response = await api.get(`member/AppInquiry/ListByMemberIdAndType/${this.memberId}/${this.type}`, null)
					this.prepareInquiry(response)
				} catch (err) {
					this.errorMessage = err.message
				} finally {
					this.loading = false
				}
			},
			prepareInquiry(rawItems) {
				let inquiry = base_inquiries.find(x => x.type === this.type)
				if (!inquiry)
					return
				const items = (rawItems || []).map(it => ({
					dateTime: `${it.date_Persian.date} ${it.date_Persian.time}` || null,
					cost: it.memberPrice,
					result: it.result ?? it.status ?? '',
					parsedResult: it.panelResultJson ? JSON.parse(it.panelResultJson) : null
				}))
				this.inquiry = {
					type: inquiry.type,
					title: inquiry.title,
					desc: inquiry.desc,
					icon: inquiry.icon,
					statusIcon: typeof (inquiry.statusIcon) === 'function' ? inquiry.statusIcon(items) : inquiry.statusIcon ?? undefined,
					iconColor: typeof (inquiry.iconColor) === 'function' ? inquiry.iconColor(items) : inquiry.iconColor ?? undefined,
					badgeColor: typeof (inquiry.badgeColor) === 'function' ? inquiry.badgeColor(items) : inquiry.badgeColor ?? undefined,
					active: Boolean(inquiry.active),
					price: this.businessAuthorizationPrice,
					result: items?.length ? items[0].result : '',
					items
				}
			},
			formatPrice(val) {
				if (val === null || val === undefined || val === '') return '0'
				try {
					return String(Number(val)).toPriceFormat ? String(Number(val)).toPriceFormat() : Number(val).toLocaleString('fa-IR')
				} catch {
					return String(val)
				}
			},
			resultColor(res) {
				const r = (res || '').toString().toLowerCase()
				if (!r) return 'grey'
				if (['success', 'ok', 'موفق', 'تایید', 'مثبت', 'دارد'].some(k => r.includes(k))) return 'green'
				if (['fail', 'error', 'ناموفق', 'رد', 'منفی', 'عدم'].some(k => r.includes(k))) return 'red'
				return 'blue'
			},
			normalizeResult(res) {
				if (!res) return '---'
				return String(res)
			},
			async submitInquiry() {
				if (await this.$refs.confirm.open(
					'توجه',
					'آیا از ارسال درخواست استعلام مطمئن هستید؟',
				)) {
					let data = {
						memberAuthorizationItemId: this.localMemberAuthorizationItem?.id,
						userLoanRequestAuthorizationItemId: this.userLoanRequestAuthorizationItem?.id,
						inquiryType: this.type,
						memberId: this.memberId
					}
					this.submitInquiryLoading = true
					api.post('member/MemberAuthorizationItem/InquiryRequest', data)
						.then(response => {
							toast.success('درخواست با موفقیت ثبت شد.')
							this.loadInquiries()
						})
						.catch(err => {
							toast.error(err.message)
						})
						.finally(() => {
							this.submitInquiryLoading = false
						})
				}
			},
			showWalletCreditCharge() {
				this.dialogWalletCreditCharge = true
			},
			callbck_walletCreditCharge() {
				this.dialogWalletCreditCharge = false
			}
		}
	}
</script>

<style scoped>

	/* Mobile-friendly tweaks */
	@media (max-width: 600px) {
		.v-card__title {
			padding: 12px 16px !important;
		}
	}
</style>
